// @generated by protoc-gen-connect-es v1.1.3 with parameter "target=ts"
// @generated from file gdx/gateway/web/myprofile/v1/my_profile_api.proto (package gdx.gateway.web.myprofile.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { CheckEmailRequest, CheckEmailResponse, ConfirmNewPasswordRequest, ConfirmNewPasswordResponse, DeactivateAccountRequest, DeactivateAccountResponse, DeleteAccountRequest, DeleteAccountResponse, DeletePhotoRequest, DeletePhotoResponse, GetAccountRequest, GetAccountResponse, GetDuplicateStateRequest, GetDuplicateStateResponse, GetExternalUserInfoRequest, GetExternalUserInfoResponse, GetFacebookTrackingParamsRequest, GetFacebookTrackingParamsResponse, GetFullProfileRequest, GetFullProfileResponse, GetIsBookPurchasedRequest, GetIsBookPurchasedResponse, GetIsRecordableRequest, GetIsRecordableResponse, GetIsSafeRequest, GetIsSafeResponse, GetOneTimeHashRequest, GetOneTimeHashResponse, GetShortProfileRequest, GetShortProfileResponse, GetStateRequest, GetStateResponse, GetTikTokRoutingRequest, GetTikTokRoutingResponse, GetTrustPilotReviewFormURLRequest, GetTrustPilotReviewFormURLResponse, ListNamesRequest, ListNamesResponse, ListProfileTagsRequest, ListProfileTagsResponse, ReactivateAccountRequest, ReactivateAccountResponse, SelectPrimaryAccountRequest, SelectPrimaryAccountResponse, SendConfirmationCodeRequest, SendConfirmationCodeResponse, SendPasswordRestorationRequest, SendPasswordRestorationResponse, SetSettingsRequest, SetSettingsResponse, SignInRequest, SignInResponse, SignOutRequest, SignOutResponse, SignUpRequest, SignUpResponse, StoreClientEventRequest, StoreClientEventResponse, SubmitOffboardingSurveyRequest, SubmitOffboardingSurveyResponse, SubmitTrustPilotReviewRequest, SubmitTrustPilotReviewResponse, UpdateAvatarRequest, UpdateAvatarResponse, UpdateProfileLocationRequest, UpdateProfileLocationResponse, UpdateProfileRequest, UpdateProfileResponse, UploadPhotoRequest, UploadPhotoResponse, ValidateConfirmationCodeRequest, ValidateConfirmationCodeResponse, ValidateEmailRequest, ValidateEmailResponse, VerifyEmailRequest, VerifyEmailResponse } from "./my_profile_api_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * Contains methods for creating and managing own profile.
 *
 * @generated from service gdx.gateway.web.myprofile.v1.MyProfileAPI
 */
export const MyProfileAPI = {
  typeName: "gdx.gateway.web.myprofile.v1.MyProfileAPI",
  methods: {
    /**
     * Initiates sign up process. Returns auth token.
     * Errors:
     * 6 - if user already exists.
     *
     * @generated from rpc gdx.gateway.web.myprofile.v1.MyProfileAPI.SignUp
     */
    signUp: {
      name: "SignUp",
      I: SignUpRequest,
      O: SignUpResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Validate user email.
     *
     * @generated from rpc gdx.gateway.web.myprofile.v1.MyProfileAPI.ValidateEmail
     */
    validateEmail: {
      name: "ValidateEmail",
      I: ValidateEmailRequest,
      O: ValidateEmailResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Validate user email with additional checks.
     *
     * @generated from rpc gdx.gateway.web.myprofile.v1.MyProfileAPI.CheckEmail
     */
    checkEmail: {
      name: "CheckEmail",
      I: CheckEmailRequest,
      O: CheckEmailResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Can be used during sign up process to retrieve filled form fields with information from Facebook or other networks.
     *
     * @generated from rpc gdx.gateway.web.myprofile.v1.MyProfileAPI.GetExternalUserInfo
     */
    getExternalUserInfo: {
      name: "GetExternalUserInfo",
      I: GetExternalUserInfoRequest,
      O: GetExternalUserInfoResponse,
      kind: MethodKind.Unary,
    },
    /**
     * List frequently used names.
     *
     * @generated from rpc gdx.gateway.web.myprofile.v1.MyProfileAPI.ListNames
     */
    listNames: {
      name: "ListNames",
      I: ListNamesRequest,
      O: ListNamesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Authenticates user by email-password or external auth.
     * Errors:
     * 16 - if user credentials are wrong.
     * 9 - if user are banned
     *
     * @generated from rpc gdx.gateway.web.myprofile.v1.MyProfileAPI.SignIn
     */
    signIn: {
      name: "SignIn",
      I: SignInRequest,
      O: SignInResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Signs out current user and invalidates current token.
     *
     * @generated from rpc gdx.gateway.web.myprofile.v1.MyProfileAPI.SignOut
     */
    signOut: {
      name: "SignOut",
      I: SignOutRequest,
      O: SignOutResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Initiates password restore password process.
     *
     * @generated from rpc gdx.gateway.web.myprofile.v1.MyProfileAPI.SendPasswordRestoration
     */
    sendPasswordRestoration: {
      name: "SendPasswordRestoration",
      I: SendPasswordRestorationRequest,
      O: SendPasswordRestorationResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Completes password restore by saving new password, invalidating all previous tokens and retrieving new token pair.
     * Errors:
     * 5 ( NOT_FOUND ) - if `session_hash` is wrong.
     *
     * @generated from rpc gdx.gateway.web.myprofile.v1.MyProfileAPI.ConfirmNewPassword
     */
    confirmNewPassword: {
      name: "ConfirmNewPassword",
      I: ConfirmNewPasswordRequest,
      O: ConfirmNewPasswordResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Returns short version of user profile data.
     *
     * @generated from rpc gdx.gateway.web.myprofile.v1.MyProfileAPI.GetShortProfile
     */
    getShortProfile: {
      name: "GetShortProfile",
      I: GetShortProfileRequest,
      O: GetShortProfileResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Returns full version of user profile data.
     *
     * @generated from rpc gdx.gateway.web.myprofile.v1.MyProfileAPI.GetFullProfile
     */
    getFullProfile: {
      name: "GetFullProfile",
      I: GetFullProfileRequest,
      O: GetFullProfileResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Updates current user avatar.
     *
     * @generated from rpc gdx.gateway.web.myprofile.v1.MyProfileAPI.UpdateAvatar
     */
    updateAvatar: {
      name: "UpdateAvatar",
      I: UpdateAvatarRequest,
      O: UpdateAvatarResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Updates one or more profile fields.
     *
     * @generated from rpc gdx.gateway.web.myprofile.v1.MyProfileAPI.UpdateProfile
     */
    updateProfile: {
      name: "UpdateProfile",
      I: UpdateProfileRequest,
      O: UpdateProfileResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Updates profile location field.
     *
     * @generated from rpc gdx.gateway.web.myprofile.v1.MyProfileAPI.UpdateProfileLocation
     */
    updateProfileLocation: {
      name: "UpdateProfileLocation",
      I: UpdateProfileLocationRequest,
      O: UpdateProfileLocationResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Upload new photo to user profile photo gallery.
     *
     * @generated from rpc gdx.gateway.web.myprofile.v1.MyProfileAPI.UploadPhoto
     */
    uploadPhoto: {
      name: "UploadPhoto",
      I: UploadPhotoRequest,
      O: UploadPhotoResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Delete photo from user profile photo gallery.
     *
     * @generated from rpc gdx.gateway.web.myprofile.v1.MyProfileAPI.DeletePhoto
     */
    deletePhoto: {
      name: "DeletePhoto",
      I: DeletePhotoRequest,
      O: DeletePhotoResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Returns current profile state.
     *
     * @generated from rpc gdx.gateway.web.myprofile.v1.MyProfileAPI.GetState
     */
    getState: {
      name: "GetState",
      I: GetStateRequest,
      O: GetStateResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Returns basic account details.
     *
     * @generated from rpc gdx.gateway.web.myprofile.v1.MyProfileAPI.GetAccount
     */
    getAccount: {
      name: "GetAccount",
      I: GetAccountRequest,
      O: GetAccountResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Initiates profile delete process.
     *
     * @generated from rpc gdx.gateway.web.myprofile.v1.MyProfileAPI.DeleteAccount
     */
    deleteAccount: {
      name: "DeleteAccount",
      I: DeleteAccountRequest,
      O: DeleteAccountResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Initiates profile Deactivate process.
     *
     * @generated from rpc gdx.gateway.web.myprofile.v1.MyProfileAPI.DeactivateAccount
     */
    deactivateAccount: {
      name: "DeactivateAccount",
      I: DeactivateAccountRequest,
      O: DeactivateAccountResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Initiates profile reactivate process.
     *
     * @generated from rpc gdx.gateway.web.myprofile.v1.MyProfileAPI.ReactivateAccount
     */
    reactivateAccount: {
      name: "ReactivateAccount",
      I: ReactivateAccountRequest,
      O: ReactivateAccountResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Stores event that occurred on app client.
     *
     * @generated from rpc gdx.gateway.web.myprofile.v1.MyProfileAPI.StoreClientEvent
     */
    storeClientEvent: {
      name: "StoreClientEvent",
      I: StoreClientEventRequest,
      O: StoreClientEventResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Submits client offboarding survey.
     *
     * @generated from rpc gdx.gateway.web.myprofile.v1.MyProfileAPI.SubmitOffboardingSurvey
     */
    submitOffboardingSurvey: {
      name: "SubmitOffboardingSurvey",
      I: SubmitOffboardingSurveyRequest,
      O: SubmitOffboardingSurveyResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Get auth hash.
     *
     * @generated from rpc gdx.gateway.web.myprofile.v1.MyProfileAPI.GetOneTimeHash
     */
    getOneTimeHash: {
      name: "GetOneTimeHash",
      I: GetOneTimeHashRequest,
      O: GetOneTimeHashResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Params list to match users & event.
     *
     * @generated from rpc gdx.gateway.web.myprofile.v1.MyProfileAPI.GetFacebookTrackingParams
     */
    getFacebookTrackingParams: {
      name: "GetFacebookTrackingParams",
      I: GetFacebookTrackingParamsRequest,
      O: GetFacebookTrackingParamsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Params list for tiktok users.
     *
     * @generated from rpc gdx.gateway.web.myprofile.v1.MyProfileAPI.GetTikTokRouting
     */
    getTikTokRouting: {
      name: "GetTikTokRouting",
      I: GetTikTokRoutingRequest,
      O: GetTikTokRoutingResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Check whether user frauder or not. Term `isSafe` is used to not make unnecessary attention in network panel.
     *
     * @generated from rpc gdx.gateway.web.myprofile.v1.MyProfileAPI.GetIsSafe
     */
    getIsSafe: {
      name: "GetIsSafe",
      I: GetIsSafeRequest,
      O: GetIsSafeResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Sends verification email to user.
     * Possible errors:
     *  FAILED_PRECONDITION - if resend earlier than 50 seconds
     *  RESOURCE_EXHAUSTED - if 6 emails already sent
     *
     * @generated from rpc gdx.gateway.web.myprofile.v1.MyProfileAPI.VerifyEmail
     */
    verifyEmail: {
      name: "VerifyEmail",
      I: VerifyEmailRequest,
      O: VerifyEmailResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Check Recordable limit.
     * Possible errors:
     *  RESOURCE_EXHAUSTED - if recordable limit is exhausted
     *
     * @generated from rpc gdx.gateway.web.myprofile.v1.MyProfileAPI.GetIsRecordable
     */
    getIsRecordable: {
      name: "GetIsRecordable",
      I: GetIsRecordableRequest,
      O: GetIsRecordableResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Checks if user purchased a book.
     *
     * @generated from rpc gdx.gateway.web.myprofile.v1.MyProfileAPI.GetIsBookPurchased
     */
    getIsBookPurchased: {
      name: "GetIsBookPurchased",
      I: GetIsBookPurchasedRequest,
      O: GetIsBookPurchasedResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Lists profile tags.
     *
     * @generated from rpc gdx.gateway.web.myprofile.v1.MyProfileAPI.ListProfileTags
     */
    listProfileTags: {
      name: "ListProfileTags",
      I: ListProfileTagsRequest,
      O: ListProfileTagsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Submits trustpilot review.
     *
     * @generated from rpc gdx.gateway.web.myprofile.v1.MyProfileAPI.SubmitTrustPilotReview
     */
    submitTrustPilotReview: {
      name: "SubmitTrustPilotReview",
      I: SubmitTrustPilotReviewRequest,
      O: SubmitTrustPilotReviewResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Returns review form url.
     *
     * @generated from rpc gdx.gateway.web.myprofile.v1.MyProfileAPI.GetTrustPilotReviewFormURL
     */
    getTrustPilotReviewFormURL: {
      name: "GetTrustPilotReviewFormURL",
      I: GetTrustPilotReviewFormURLRequest,
      O: GetTrustPilotReviewFormURLResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Sets profile settings.
     *
     * @generated from rpc gdx.gateway.web.myprofile.v1.MyProfileAPI.SetSettings
     */
    setSettings: {
      name: "SetSettings",
      I: SetSettingsRequest,
      O: SetSettingsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Get primary duplicate selection state.
     * NOT_FOUND if list ID is not found.
     *
     * @generated from rpc gdx.gateway.web.myprofile.v1.MyProfileAPI.GetDuplicateState
     */
    getDuplicateState: {
      name: "GetDuplicateState",
      I: GetDuplicateStateRequest,
      O: GetDuplicateStateResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Selects one profile from candidate list
     * NOT_FOUND - if list or profile_id is not found.
     * FAILED_PRECONDITION - if profile_id is not a member of candidates list.
     *
     * @generated from rpc gdx.gateway.web.myprofile.v1.MyProfileAPI.SelectPrimaryAccount
     */
    selectPrimaryAccount: {
      name: "SelectPrimaryAccount",
      I: SelectPrimaryAccountRequest,
      O: SelectPrimaryAccountResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Generate and send confirmation code to user.
     *
     * @generated from rpc gdx.gateway.web.myprofile.v1.MyProfileAPI.SendConfirmationCode
     */
    sendConfirmationCode: {
      name: "SendConfirmationCode",
      I: SendConfirmationCodeRequest,
      O: SendConfirmationCodeResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Validates provided code.
     * INVALID_ARGUMENT if code is invalid or expired.
     *
     * @generated from rpc gdx.gateway.web.myprofile.v1.MyProfileAPI.ValidateConfirmationCode
     */
    validateConfirmationCode: {
      name: "ValidateConfirmationCode",
      I: ValidateConfirmationCodeRequest,
      O: ValidateConfirmationCodeResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

